import { createApp } from "vue";
import axios from "axios";
axios.defaults.headers.common["API-KEY"] = "CEGAChAtA7Ds40p";
import App from "./App.vue";
import VueAxios from "vue-axios";
const app = createApp(App);
app.use(VueAxios, axios);
app.mount("#app");
